import { render, staticRenderFns } from "./AuditFormRealizedAllProcedures.vue?vue&type=template&id=2e33c190&"
import script from "./AuditFormRealizedAllProcedures.vue?vue&type=script&lang=js&"
export * from "./AuditFormRealizedAllProcedures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox})
